import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';



// Components
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { BannerComponent } from './components/banner/banner.component';
import { CallToActionComponent } from './components/call-to-action/call-to-action.component';
import { SidebarToplistComponent } from './components/sidebar-toplist/sidebar-toplist.component';
import { JobCardComponent } from './components/job-card/job-card.component';
import { NewJobOfferComponent } from './components/new-job-offer/new-job-offer.component';


// Pages
import { FooterComponent } from './components/footer/footer.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { CandidatAccountComponent } from './pages/candidat-account/candidat-account.component';
import { MyBackupComponent } from './pages/my-backup/my-backup.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { HomeComponent } from './pages/home/home.component';
import { EducationsComponent } from './pages/educations/educations.component';
import { AdviceComponent } from './pages/advice/advice.component';
import { ApplyJobComponent } from './pages/apply-job/apply-job.component';
import { JobListComponent } from './pages/job-list/job-list.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CompanyAccountComponent } from './pages/company-account/company-account.component';
import { PortalComponent } from './pages/portal/portal.component';
import { CompanyJobListComponent } from './pages/company-job-list/company-job-list.component';
import { PostJobOfferComponent } from './pages/post-job-offer/post-job-offer.component';
import { JobDetailsComponent } from './pages/job-details/job-details.component';
import { CandidateApplyJobComponent } from './pages/candidate-apply-job/candidate-apply-job.component';
import { CandidateListComponent } from './pages/candidate-list/candidate-list.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { OursCustomersComponent } from './pages/ours-customers/ours-customers.component';
import { OursFilialesComponent } from './pages/ours-filiales/ours-filiales.component';
import { CandidateProfileComponent } from './pages/candidate-profile/candidate-profile.component';
import { ConsultantAccountComponent } from './pages/consultant-account/consultant-account.component';
import { ConsultantListComponent } from './pages/consultant-list/consultant-list.component';
import { ConsultantProfileComponent } from './pages/consultant-profile/consultant-profile.component';
import { ContactComponent } from './pages/contact/contact.component';
import { OursProductsComponent } from './pages/ours-products/ours-products.component';
import { CurriculumVitaeComponent } from './pages/curriculum-vitae/curriculum-vitae.component';

// Pages admin
import { AdminSignInComponent } from './pages/admin-sign-in/admin-sign-in.component';
import { AdminHomeComponent } from './pages/admin-home/admin-home.component';
import { AdminPostJobOfferComponent } from './pages/admin-post-job-offer/admin-post-job-offer.component';
import { AdminJobListComponent } from './pages/admin-job-list/admin-job-list.component';
import { AdminCandidateApplyJobComponent } from './pages/admin-candidate-apply-job/admin-candidate-apply-job.component';
import { AdminCandidateProfileComponent } from './pages/admin-candidate-profile/admin-candidate-profile.component';
import { AdminCompanyListComponent } from './pages/admin-company-list/admin-company-list.component';
import { AdminAdminListComponent } from './pages/admin-admin-list/admin-admin-list.component';

// Services
import { UsersService } from './services/users.service'
import { FunctionsService } from './services/functions.service';
import { HttpService } from './services/http.service';
import { AuthGuard } from './services/auth-guard.service';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AccueilComponent } from './pages/accueil/accueil.component';
import { ConfianceComponent } from './confiance/confiance.component';
import { CandidatCertificatsComponent } from './pages/candidat-certificats/candidat-certificats.component';
import { CandidatLanguagesComponent } from './pages/candidat-languages/candidat-languages.component';
import { CandidatTrainingComponent } from './pages/candidat-training/candidat-training.component';
import { CandidatSoftwareComponent } from './pages/candidat-software/candidat-software.component';
import { CandidatExperiencesComponent } from './pages/candidat-experiences/candidat-experiences.component';
import { CandidatInfosComponent } from './pages/candidat-infos/candidat-infos.component';
import { CandidatExperienceUpdateComponent } from './pages/candidat-experience-update/candidat-experience-update.component';
import { CandidatTrainningEditComponent } from './pages/candidat-trainning-edit/candidat-trainning-edit.component';
import { AdminCreateCompanyComponent } from './pages/admin-create-company/admin-create-company.component';
import { VisionValeursComponent } from './pages/vision-valeurs/vision-valeurs.component';
import { ContactCabinetComponent } from './pages/contact-cabinet/contact-cabinet.component';
import { DepotCvComponent } from './pages/depot-cv/depot-cv.component';
import { ArticlesComponent } from './components/articles/articles.component';
import { AutresitesComponent } from './components/autresites/autresites.component';
import { CandidatProfileRecrutementComponent } from './pages/candidat-profile-recrutement/candidat-profile-recrutement.component';
import { AdminJobCardComponent } from './pages/admin-job-card/admin-job-card.component';
import { OffresDeFormationComponent } from './pages/offres-de-formation/offres-de-formation.component';
import { SirhComponent } from './pages/sirh/sirh.component';
import { TeamComponent } from './pages/team/team.component';
import { IntraEntrepriseComponent } from './pages/intra-entreprise/intra-entreprise.component';



const appRoutes: Routes = [
  { path: 'admin/administrateur', component: AdminAdminListComponent },
  { path: 'admin/details-candidat/:candidatID', component: AdminCandidateProfileComponent },
  { path: 'admin/candidats-offre/:jobID', component: AdminCandidateApplyJobComponent },
  { path: 'admin/offres-emploi/:companyID', component: AdminJobListComponent },
  { path: 'admin/publier-offre-emploi', component: AdminPostJobOfferComponent },
  { path: 'admin/entreprises', component: AdminCompanyListComponent },
  { path: 'admin/ajouter-entreprises', component: AdminCreateCompanyComponent },
  { path: 'admin', component: AdminHomeComponent },
  { path: 'admin/connexion', component: AdminSignInComponent },
  { path: 'tous-les-consultants', canActivate: [AuthGuard], component: ConsultantListComponent },
  { path: 'profile-consultant/:consultantID', canActivate: [AuthGuard], component: ConsultantProfileComponent },
  { path: 'tous-les-candidats', canActivate: [AuthGuard], component: CandidateListComponent },
  { path: 'profile-candidat/:candidatID', canActivate: [AuthGuard], component: CandidateProfileComponent },
  { path: 'candidats-offre/:jobID', canActivate: [AuthGuard], component: CandidateApplyJobComponent },
  { path: 'publier-offre-emploi', canActivate: [AuthGuard], component: PostJobOfferComponent },
  { path: 'mes-offres-emploi', canActivate: [AuthGuard], component: CompanyJobListComponent },
  { path: 'compte-entreprise', canActivate: [AuthGuard], component: CompanyAccountComponent },
  { path: 'postuler/:jobID', canActivate: [AuthGuard], component: ApplyJobComponent },
  { path: 'conseils', component: AdviceComponent },
  { path: 'formations', component: EducationsComponent },
  { path: 'mes-sauvegardes', canActivate: [AuthGuard], component: MyBackupComponent },
  { path: 'compte-consultant', canActivate: [AuthGuard], component: ConsultantAccountComponent },

  { path: 'compte-candidat', canActivate: [AuthGuard], component: CandidatAccountComponent },

  { path: 'candidat-infos', canActivate: [AuthGuard], component: CandidatInfosComponent },
  { path: 'candidat-certificates', canActivate: [AuthGuard], component: CandidatCertificatsComponent },
  { path: 'candidat-languages', canActivate: [AuthGuard], component: CandidatLanguagesComponent },
  { path: 'candidat-trainings', canActivate: [AuthGuard], component: CandidatTrainingComponent },
  { path: 'candidat-training-edit', canActivate: [AuthGuard], component: CandidatTrainningEditComponent },
  { path: 'candidat-software', canActivate: [AuthGuard], component: CandidatSoftwareComponent },
  { path: 'candidat-experiences', canActivate: [AuthGuard], component: CandidatExperiencesComponent },
  { path: 'candidat-experience-update', canActivate: [AuthGuard], component: CandidatExperienceUpdateComponent },

  { path: 'profile-recrutement', canActivate: [AuthGuard], component: CandidatProfileRecrutementComponent },




  { path: 'creer-mot-de-passe/:typeUser', component: ChangePasswordComponent },
  { path: 'changer-mot-de-passe/:typeUser', canActivate: [AuthGuard], component: ChangePasswordComponent },
  { path: 'mot-de-passe-oublie/:typeUser', component: ResetPasswordComponent },
  { path: 'inscription', component: SignUpComponent },
  { path: 'connexion', component: SignInComponent },
  { path: 'accueil/:typeUser', canActivate: [AuthGuard], component: HomeComponent },
  { path: 'portail', component: PortalComponent },
  { path: 'nos-clients', component: OursCustomersComponent },

  { path: 'cv/:submenu', component: CurriculumVitaeComponent },
  { path: 'depot-cv', canActivate: [AuthGuard], component: DepotCvComponent },

  { path: 'contact/:submenu', component: ContactComponent },
  { path: 'contact', component: ContactCabinetComponent },
  { path: 'filiales/:submenu', component: OursFilialesComponent },
  { path: 'nos-produits/:submenu', component: OursProductsComponent },
  { path: 'a-propos/:submenu', component: AboutUsComponent },
  { path: 'nos-equipes', component: TeamComponent },
  { path: 'visions-valeurs', component: VisionValeursComponent },
  { path: 'offres-emploi/:jobID', component: JobDetailsComponent },
  { path: 'formation/:submenu', component: OffresDeFormationComponent },
  { path: '', component: AccueilComponent },
  { path: 'job-list', component: JobListComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    BannerComponent,
    CallToActionComponent,
    FooterComponent,
    SignInComponent,
    SignUpComponent,
    CandidatAccountComponent,
    MyBackupComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    EducationsComponent,
    AdviceComponent,
    ApplyJobComponent,
    JobListComponent,
    NotFoundComponent,
    CompanyAccountComponent,
    PortalComponent,
    CompanyJobListComponent,
    PostJobOfferComponent,
    JobDetailsComponent,
    CandidateApplyJobComponent,
    CandidateListComponent,
    HomeComponent,
    AdminSignInComponent,
    AdminHomeComponent,
    AdminPostJobOfferComponent,
    AdminJobListComponent,
    SidebarToplistComponent,
    JobCardComponent,
    AdminCandidateProfileComponent,
    AdminCandidateApplyJobComponent,
    AboutUsComponent,
    OursCustomersComponent,
    OursFilialesComponent,
    CandidateProfileComponent,
    NewJobOfferComponent,
    AdminCompanyListComponent,
    AdminAdminListComponent,
    ConsultantAccountComponent,
    ConsultantListComponent,
    ConsultantProfileComponent,
    ContactComponent,
    OursProductsComponent,
    CurriculumVitaeComponent,
    AccueilComponent,
    ConfianceComponent,
    CandidatCertificatsComponent,
    CandidatLanguagesComponent,
    CandidatTrainingComponent,
    CandidatSoftwareComponent,
    CandidatExperiencesComponent,
    CandidatInfosComponent,
    CandidatExperienceUpdateComponent,
    CandidatTrainningEditComponent,
    AdminCreateCompanyComponent,
    VisionValeursComponent,
    ContactCabinetComponent,
    DepotCvComponent,
    ArticlesComponent,
    AutresitesComponent,
    CandidatProfileRecrutementComponent,
    AdminJobCardComponent,
    OffresDeFormationComponent,
    SirhComponent,
    TeamComponent,
    IntraEntrepriseComponent,

  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    DatePipe,
    UsersService,
    FunctionsService,
    HttpService,
    AuthGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
